export default __webpack_public_path__ + "static/nxkabasulu-e8169ac10ec5faf852ec8a6750dbbe0d.webp";